import React from 'react'
import writeXlsxFile from 'write-excel-file/browser';
import { connect } from 'react-redux';
import ExportExcelButton from './ExportExcelButton';
const fileExtension = '.xlsx';
const MonthString = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export class ExportCSV extends React.Component{
  formatDate = (date) => {
    let dateObj = new Date(date);
    let dateStr = dateObj.getDate() >= 10 ? dateObj.getDate() : '0' + dateObj.getDate()
    let monthStr = MonthString[dateObj.getMonth()];
    let YearStr = '' + dateObj.getFullYear()
    YearStr = YearStr.toString().slice(-2)
    return dateStr + '-' + monthStr + '-' + YearStr;
  }
    downloadExcel = async () => {
      const csvData = this.preparreData();
      let fileName = this.props.fileName;
      const headers = Object.keys(csvData[0] || {});
      const rows = [
        headers.map((header) => ({ value: header, fontWeight: 'bold' })),
        ...csvData.map((item) =>
          headers.map((header) => ({
            value: item[header] == null ? '' : String(item[header]),
          }))
        ),
      ];

      await writeXlsxFile(rows, { sheet: 'data' }).toFile(
        fileName + fileExtension
      );
    }
    preparreData = ()=>{      
      // console.log("checking xl",this.props.keys,this.props.data,this.props.addSerialNo)
      let excelObj = []      
        this.props.data.forEach((item,ind)=>{
          let dataObj = {}
          if(this.props.addSerialNo){
            dataObj['S.No.']=ind+1;
          }          
          this.props.keys.forEach((key,index)=>{            
              dataObj[this.props.cellHeaders[index]]=item[key];
          })
          excelObj.push(dataObj);
        })
      return excelObj;
    }    
    
    render(){
    return (
      <ExportExcelButton onClick={this.downloadExcel} />
    )
    }
}
const mapStateToProps = state => {
 
  return {
    dashboardData: state.dashboardData
  };
};
export default connect(mapStateToProps,  {
  
})(ExportCSV);